import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  MmButtonModule,
  MmCheckboxModule,
  MmDialogModule,
  MmFormFieldModule,
  MmIconModule,
  MmSpinnerModule,
  MmRadioModule,
  MmTableModule,
  MmTooltipModule,
  MmTooltipOptionsModel,
  MM_BREAKPOINTS,
  MmFlexLayoutModule,
} from '@metromarkets/components';
import { FeatureToggleModule, QaLocatorsModule } from '@metromarkets/sdk';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BREAKPOINT, FlexLayoutModule } from '@angular/flex-layout';

import { MediaControlModule } from '~shared/modules/media-control/media-control.module';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { AdvancedFormModule } from '~shared/modules/advanced-form/advanced-form.module';
import { EmailSentModule } from '~shared/modules/email-sent/email-sent.module';

import { AuthorizationRoutingModule } from './authorization-routing.module';
import { AuthorizationComponent } from './components/authorization/authorization.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { AuthorizationService } from './services/authorization.service';

import { AddBusinessDetailsComponent } from './components/add-business-details/add-business-details.component';
import { IDAMRegisterComponent } from './components/idam-register/idam-register.component';
import { SSOComponent } from '~app/modules/authorization/components/fd-sso/sso.component';
import { ValidateEmailComponent } from './components/validate-email/validate-email.component';
import { NoSpacesModule } from '~shared/directives/no-spaces/no-spaces.module';
// prettier-ignore
import {
  RegistrationBusinessTypeComponent
} from './components/registration-business-type/registration-business-type.component';
// prettier-ignore
import {
  VatKvkIdCheckForTierTwoSignupComponent
} from './components/vat-kvk-id-check-for-tier-two-signup/vat-kvk-id-check-for-tier-two-signup.component';
// eslint-disable-next-line max-len
import { RedirectFromTierOneSignupDialogComponent } from './components/redirect-from-tier-one-signup-dialog/redirect-from-tier-one-signup-dialog.component';
import { PasswordlessSignupComponent } from './components/passwordless-signup/passwordless-signup.component'; // NOSONAR
import { LoginFlowTypeComponent } from './components/login-flow-type/login-flow-type.component';
import { BranchSelectionComponent } from './components/branch-selection/branch-selection.component';
// prettier-ignore
import {
  PasswordlessIntermediatePageComponent,
} from './components/passwordless-intermediate-page/passwordless-intermediate-page.component';
import { CustomersListComponent } from './components/customers-list/customers-list.component';
import { AppCreateDigitalAccountDialogModule } from '~shared/components/create-digital-account-dialog/create-digital-account-dialog.module';
import { AppConfirmAccountCredentialsDialogModule } from '~shared/components/confirm-account-credentials-dialog/confirm-account-credentials-dialog.module';
import { AppEmployeeOverviewNavigationAlertDialogModule } from '~shared/components/employee-overview-page-redirection-alert-dialog/employee-overview-navigation-alert-dialog.module';

const TooltipOptions: MmTooltipOptionsModel = {
  placement: 'bottom',
  hideDelay: 400,
  tooltipColor: 'blue',
};

@NgModule({
  declarations: [
    AuthorizationComponent,
    SSOComponent,
    IDAMRegisterComponent,
    RegistrationComponent,
    RegistrationBusinessTypeComponent,
    AddBusinessDetailsComponent,
    ValidateEmailComponent,
    VatKvkIdCheckForTierTwoSignupComponent,
    RedirectFromTierOneSignupDialogComponent,
    PasswordlessSignupComponent,
    LoginFlowTypeComponent,
    BranchSelectionComponent,
    PasswordlessIntermediatePageComponent,
    CustomersListComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MmCheckboxModule,
    MmFormFieldModule,
    MmButtonModule,
    MmDialogModule,
    MmRadioModule,
    QaLocatorsModule,
    FeatureToggleModule,
    BasePageModule,
    AdvancedFormModule,
    AuthorizationRoutingModule,
    MediaControlModule,
    EmailSentModule,
    MmIconModule,
    MmSpinnerModule,
    NoSpacesModule,
    MmTableModule,
    AppCreateDigitalAccountDialogModule,
    AppConfirmAccountCredentialsDialogModule,
    AppEmployeeOverviewNavigationAlertDialogModule,
    MmTooltipModule.forRoot(TooltipOptions),
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    MmFlexLayoutModule,
  ],
  providers: [AuthorizationService, { provide: BREAKPOINT, useValue: MM_BREAKPOINTS, multi: true }],
})
export class AuthorizationModule {}
